import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './ActiveFilterPills.css';

// Renders one pill per currently-applied filter as "Label: value", each with
// its own clear button - so a filter can be dropped individually instead of
// only via "Clear Filters" (which resets everything at once).
const ActiveFilterPills = ({ pills }) => {
    const visiblePills = pills?.filter((pill) => pill.value) || [];

    if (visiblePills.length === 0) return null;

    return (
        <div className="activeFilterPillsRow">
            {visiblePills.map((pill) => (
                <span className="activeFilterPill" key={pill.key}>
                    <span className="activeFilterPillLabel">{pill.label}:</span>
                    <span className="activeFilterPillValue">{pill.value}</span>
                    <button
                        type="button"
                        className="activeFilterPillClearBtn"
                        aria-label={`Clear ${pill.label} filter`}
                        onClick={pill.onClear}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </span>
            ))}
        </div>
    );
};

export default ActiveFilterPills;
